import React, { useEffect, useRef, useState } from "react";
import { Modal } from "@mui/material";
import { makeStyles } from "@material-ui/styles";
// import iconCustomSelected from "../../../../../assets/images/custom-value-icon-selected.png";
// import iconCustom from "../../../../../assets/images/custom-value-icon.png";
import { useTheme } from "../../../../../hook/useThemes";
import {
  activeEventFathom,
  // formatNumberForOdds,
} from "../../../../../utils/utils";
import { useSearchParams } from "react-router-dom";

interface IPropsModalConfirm {
  valueBetDefault: any;
  open: boolean;
  onClose: () => void;
  onConfirm: (value: any) => void;
}

export default function ModalSelectBet(props: IPropsModalConfirm) {
  const { lang, default_bet = 1, list_bet } = useTheme();
  const { valueBetDefault = default_bet, open, onClose, onConfirm } = props;
  const [searchParams] = useSearchParams();
  const demo = searchParams.get("demo") === "true";

  const len = list_bet?.length || 1;
  const MAX = demo ? 1000 : list_bet[len - 1] || 1000;

  const [valueBet, setValueBet] = useState<any>();
  const [valueInput, setValueInput] = useState<any>("");

  // const [isSelectCustom, setIsSelectCustom] = useState<boolean>(true);
  const refInput = useRef<any>();
  const classes = useStyles();

  // const LIST_VALUE_BET = [1, 5, 10];

  useEffect(() => {
    setValueInput("");
    // setIsSelectCustom(false);
    setValueBet(valueBetDefault);
  }, [open, valueBetDefault]);

  useEffect(() => {
    if (open && refInput.current) {
      refInput.current.focus();
    }
  }, [open, refInput.current]);

  const handleConfirm = () => {
    onConfirm(valueBet);
    onClose();
    activeEventFathom("StakeModal-Confirm");
  };

  const handleCloseModal = () => {
    onClose();
  };

  // const handleClickCustomBet = () => {
  //   if (refInput.current) {
  //     refInput.current.focus();
  //   }
  // };

  const handleOnChangeInput = (e: any) => {
    const value = e.target.value;
    const lenValue = value?.length || 0;

    const numberValue = Number(value);

    if (Number.isNaN(numberValue)) {
      setValueInput("");
      setValueBet(valueBetDefault);
      return;
    }

    if (numberValue > MAX) {
      return;
    }
    if (numberValue < 10) {
      if (lenValue < 5) {
        setValueInput(value);
        setValueBet(value || valueBetDefault);
      }
      return;
    }

    if (numberValue < 100) {
      if (lenValue < 6) {
        setValueInput(value);
        setValueBet(value || valueBetDefault);
      }
      return;
    }
    if (numberValue < 1000) {
      if (lenValue < 7) {
        setValueInput(value);
        setValueBet(value || valueBetDefault);
      }
      return;
    }

    if (numberValue <= 5000) {
      if (lenValue < 8) {
        setValueInput(value);
        setValueBet(value || valueBetDefault);
      }
      return;
    }
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={open}
      onClose={handleCloseModal}
      closeAfterTransition
      onBackdropClick={(e) => e.stopPropagation()}
    >
      <div
        className={`${classes["content-cart"]}`}
        onClick={(e) => e.stopPropagation()}
      >
        <p className="label-bet-amount">
          {lang?.customize_bet_size || "Customize bet size"}
        </p>
        {/* <p className="value-bet-amount">
          ${formatNumberForOdds(valueBet, true)}
        </p> */}
        {/* <div className="wrapper-item-bet">
          {LIST_VALUE_BET.map((item: any) => {
            return (
              <div
                className={`item-bet ${
                  !isSelectCustom && valueBet === item ? " item-bet-select" : ""
                }`}
                key={item}
                onClick={() => {
                  setValueBet(item);
                  setIsSelectCustom(false);
                }}
              >
                ${item}
              </div>
            );
          })}

          <div
            className={`item-bet ${isSelectCustom ? "item-bet-select" : ""}`}
            onClick={() => {
              setIsSelectCustom(!isSelectCustom);
              handleClickCustomBet();
              activeEventFathom("StakeModal-CustomBox")
            }}
          >
            <img
              src={isSelectCustom ? iconCustomSelected : iconCustom}
              alt=""
            />
          </div>
        </div> */}

        <div className={`wrapper-input-bet input-show`}>
          <input
            value={valueInput}
            className="input-value-bet"
            ref={refInput}
            onChange={handleOnChangeInput}
          />
          {valueInput && (
            <div className="wrap-show-value">
              <span>$</span>
              <span className="value-bet">
                {Number(valueInput).toLocaleString("en-US")}
              </span>
            </div>
          )}
          {/* <p className="placeholder">$</p> */}
        </div>

        <button className="button-confirm" onClick={handleConfirm}>
          {" "}
          {lang?.confirm || "Confirm"}
        </button>
      </div>
    </Modal>
  );
}

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    pointerEvents: "auto",
  },

  "content-cart": {
    width: "300px",
    minHeight: "200px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    background: "#0F1724",
    boxShadow: "none",
    border: "none",
    outline: "none",
    padding: "20px 40px",
    WebkitBoxShadow: "0px 4px 12px rgba(0, 0, 0, 0.75)",
    borderRadius: "12px",
    overflow: "auto",

    "& .label-bet-amount": {
      width: "100%",
      fontSize: "12px",
      lineHeight: "14px",
      color: "#F1F1F1",
      textAlign: "center",
      fontWeight: 700,
    },

    "& .value-bet-amount": {
      width: "100%",
      fontSize: "40px",
      lineHeight: "47px",
      fontWeight: 700,
      color: "#F1F1F1",
      textAlign: "center",
      margin: "24px 0px",
    },

    "& .wrapper-item-bet": {
      display: "flex",
      flexWrap: "wrap",
      gap: "12px",
      justifyContent: "center",

      "& .item-bet": {
        width: "100px",
        minWidth: "100px",
        height: "40px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontSize: "16px",
        color: "#F3F4F3",
        background: "#29303F",
        borderRadius: "24px",
        cursor: "pointer",

        // "&:hover": {
        //   color: "#29303F",
        //   background: "#F3F4F3",
        // },
      },

      "& .item-bet-select": {
        color: "#29303F",
        background: "#F3F4F3",
      },
    },

    "& .wrapper-input-bet": {
      width: "206px",
      height: "0px",
      display: "flex",
      alignItems: "center",
      margin: "16px auto 0px",
      position: "relative",
      transition: "all 0.2s",
      overflow: "hidden",

      "& .input-value-bet": {
        width: "100%",
        height: "100%",
        border: "none",
        borderBottom: "1px solid #969696",
        background: "none",
        color: "transparent",
        fontSize: "24px",
        fontWeight: 700,
        // paddingRight: "16px",
        textAlign: "center",
        caretColor: "#F1F1F1",

        "&:focus-visible": {
          borderBottom: "1px solid #969696 !important",
        },
        "&::-webkit-outer-spin-button": {
          "-webkit-appearance": "none",
          margin: 0,
        },
        "&::-webkit-inner-spin-button": {
          "-webkit-appearance": "none",
          margin: 0,
        },
      },

      "& input[type=number]": {
        "-moz-appearance": "textfield",
      },

      "& .wrap-show-value": {
        position: "absolute",
        top: 0,
        left: 0,
        pointerEvents: "none",
        width: "100%",
        height: "100%",
        textAlign: "center",
        fontSize: "24px",
        color: "#F1F1F1",
        zIndex: 1,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        paddingRight: "20px",
        gap: "4px",
        fontWeight: 700,
      },

      "& .placeholder": {
        position: "absolute",
        right: "0",
        color: "#F1F1F1",
        fontSize: "22px",
      },
    },

    "& .input-show": {
      height: "40px",
    },

    "& .button-confirm": {
      // width: "87px",
      fontWeight: 700,
      fontSize: "24px",
      lineHeight: "28px",
      color: "#F1F1F1",
      margin: "8px auto 12px",
      cursor: "pointer",
      position: "relative",
      background: "transparent",
      border: "none",

      "&::before": {
        content: "' '",
        position: "absolute",
        bottom: "0px",
        left: "0px",
        width: "100%",
        borderBottom: "2px solid #F1F1F1",
      },
    },
  },
}));
